import { createContext, useContext, useState, useEffect } from 'react'

import { createPayment } from '../api/payments'

import {
  SUBSCRIPTION_MONTH_STARS,
  SUBSCRIPTION_PERIOD,
} from '../utils/constants'
import { useApp } from './AppContext'

// Create context
const SubscriptionContext = createContext(null)

export const SubscriptionProvider = ({ children }) => {
  const { appSubscriptionInfo } = useApp()
  const [subscriptionInfo, setSubscriptionInfo] = useState(null)
  const [subscriptionHash, setSubscriptionHash] = useState(null)
  const [isHaveSubscriptionHash, setIsHaveSubscriptionHash] = useState(false)

  useEffect(() => {
    const getPayment = async () => {
      if (
        isHaveSubscriptionHash &&
        !!subscriptionInfo &&
        !!subscriptionInfo.user_data &&
        !subscriptionInfo.user_data.premium
      ) {
        const orderDetails = await createPayment(
          appSubscriptionInfo?.currency === '*'
            ? SUBSCRIPTION_MONTH_STARS
            : SUBSCRIPTION_PERIOD
        )
        setSubscriptionHash(orderDetails)
      }
    }
    getPayment()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHaveSubscriptionHash, subscriptionInfo])

  // Provide this context value to all children
  const value = {
    subscriptionInfo,
    setSubscriptionInfo,
    subscriptionHash,
    setSubscriptionHash,
    isHaveSubscriptionHash,
    setIsHaveSubscriptionHash,
  }

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  )
}

// Custom hook for using this context
export const useSubscription = () => {
  const context = useContext(SubscriptionContext)
  if (!context) {
    throw new Error(
      'useSubscription must be used within a SubscriptionProvider'
    )
  }
  return context
}
